import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppTimeZone - the browser's own IANA time zone ("Asia/Bangkok"), sent as `tz` on `/folder` and `/assist`
// so the service counts hours, days and months on the subscriber's clock (`Bridge/src/OwnerTimeZone.ts`,
// owner-approved 2026-09-27).
//
// ⚠ RULES, NO TRANSPORT (the Bridge suite imports the request builders that call this): `Intl` exists in
// both habitats. The service checks the name again (`OwnerTimeZone.Valid`) - this only reads it.

export class AppTimeZone {
    /**
     * The browser's zone, or "" when it has none to say.
     *
     * ERROR-SUPPRESSED-JUSTIFIED: an engine without `Intl` time-zone support throws or answers nothing, and
     * "" IS the answer then - the service counts in UTC, exactly as before this existed.
     */
    public static Here = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Name: unknown = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (typeof Name !== "string") { return ""; }
            return Name.substring(0, 64);
        } catch (e) {
            // ERROR-SUPPRESSED-JUSTIFIED: no zone to report is the answer "" (see above).
            return "";
        }
    };
}
